import {
  cloneElement,
  isValidElement,
  ReactElement,
  ReactNode,
  useContext,
} from 'react';
import { COMMON_STRING } from '@/constants/dictionary';
import { ScoringContext } from '@/contexts/scoring/context';
import { CustomTooltip } from '../StatsCompareTable/StyledStatsComponents';

type ArchiveGuardProps = {
  children: ReactElement<any>;
  activeTooltip?: string | ReactNode;
  hideMode?: boolean;
};

export const ArchiveGuard = ({
  children,
  activeTooltip,
  hideMode = false,
}: ArchiveGuardProps) => {
  const {
    state: { fixtureSummary },
  } = useContext(ScoringContext);

  const disabled = fixtureSummary?.isArchive;
  if (hideMode && disabled) return null;

  if (!disabled) {
    if (!activeTooltip) return <>{children}</>;
    return (
      <CustomTooltip title={activeTooltip}>
        <span>{children}</span>
      </CustomTooltip>
    );
  }

  if (!isValidElement(children)) return <>{children}</>;

  const tooltipTitle = disabled
    ? COMMON_STRING.ARCHIVED_TOOLTIP
    : activeTooltip ?? '';

  const archivedChild = cloneElement(children as ReactElement<any>, {
    disabled,
  });

  return (
    <CustomTooltip title={tooltipTitle}>
      <span
        data-testid='archive-guard-wrapper'
        style={{ display: 'inline-block' }}
      >
        {archivedChild}
      </span>
    </CustomTooltip>
  );
};
